import * as Factory from 'factory.ts'
import faker from 'faker'

import { type StripeBankAccount } from '../../models'

export const StripeBankAccountMock =
  Factory.Sync.makeFactory<StripeBankAccount>({
    account_holder_name: Factory.each(() => faker.finance.accountName()),
    account_number: Factory.each(() => faker.finance.account(4)),
    bank_account_id: Factory.each(() => faker.random.uuid()),
    bank_name: faker.lorem.word(),
    status: faker.random.arrayElement([0, 2]),
  })
